import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import $ from 'jquery';
gsap.registerPlugin(ScrollTrigger);
export default class TextSlider {
    static $element = $('.js__text-slider');
    static $pin = $('.js__text-slider-pin');
    static $scenes = $('.js__text-slider-scene');
    static init() {
        if (!this.$element.length || this.$scenes.length < 2) {
            return;
        }
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.$element.get(0),
                start: 'center center',
                end: `+=${this.$scenes.length * 50}%`,
                scrub: 1,
                pin: this.$pin.get(0),
                snap: { snapTo: 'labelsDirectional', duration: { min: 0.2, max: 0.5 }, ease: 'power1.inOut', delay: 0.2 },
            },
        });
        this.$scenes.each((index, scene) => {
            if (index === 0) {
                timeline.addLabel('start');
            }
            else {
                timeline.fromTo(scene, {
                    opacity: 0,
                    y: '25%',
                    scale: 1.1,
                    ease: 'power1.inOut',
                }, {
                    duration: 1,
                    opacity: 1,
                    y: '0%',
                    scale: 1,
                    ease: 'power1.inOut',
                }, '-=0.5');
            }
            timeline.addLabel(`scene${index}`);
            if (index !== this.$scenes.length - 1) {
                timeline.to(scene, { duration: 1, opacity: 0, y: '-25%', scale: 1.1, ease: 'power1.inOut' });
            }
            else {
                timeline.addLabel('end');
            }
        });
    }
}
